module.exports = __webpack_public_path__ + "static/img/hk_img.836343c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hk_img.png
// module id = S7r7
// module chunks = 4